const rules = {
    required: {required: true, message: '不能为空', trigger: 'blur,change'},
    requiredNumber: {type: 'number', required: true, message: '不能为空', trigger: 'blur,change'},
    requiredArray: {type: 'array', required: true, message: '不能为空', trigger: 'blur,change'},
    requiredDate: {type: 'date', required: true, message: '不能为空', trigger: 'blur,change'},
    mobile: {
        pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
        message: '手机号格式错误',
        trigger: 'blur,change'
    },
    money: {}
};
export default rules;
